import { render, staticRenderFns } from "./MasterProjectTerms.vue?vue&type=template&id=56b7cb8e&scoped=true"
import script from "./MasterProjectTerms.vue?vue&type=script&lang=js"
export * from "./MasterProjectTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7cb8e",
  null
  
)

export default component.exports